import React, { Fragment } from 'react';
import './ConfirmationPage.css';

export const ConfirmationPage = () => (
  <Fragment>
    <div className='content'>
      <div className='wrapper pad'>
        <h1>Danke.</h1>
        <p>Deine Anfrage wurde berücksichtigt*.</p>
      </div>
    </div>
  </Fragment>
);
